import { useSelector } from "react-redux";

import { selectFilteredProjectIdsCount } from "Store/Selectors/Filter";
import { selectProjectTotalCount } from "Store/Selectors/Projects";
import { useProjectCountStyles } from "./UseProjectCountStyles";

export function ProjectCount(): JSX.Element {
  const filteredProjectCount = useSelector(selectFilteredProjectIdsCount);
  const projectTotalCount = useSelector(selectProjectTotalCount);
  const styles = useProjectCountStyles();
  return <div className={styles.root}>{`${filteredProjectCount} / ${projectTotalCount}`}</div>;
}
